import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonFunction } from 'src/app/grievance/common-function';
import { Board, Departments } from 'src/app/grievance/interface/common-interface';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { GrievanceTypeService } from '../grievance-type.service';

@Component({
  selector: 'app-add-grievance-type',
  templateUrl: './add-grievance-type.component.html',
  styleUrls: ['./add-grievance-type.component.scss'],
})
export class AddGrievanceTypeComponent implements OnInit {
  levels: any = [];
  Excellationdays: any = []
  isSubmitDisabled: boolean = false;
  progressSpinnerDialog: any = null;

  protected boards: Board[] = [];
  public boardCtrl: FormControl = new FormControl();
  public boardFilterCtrl: FormControl = new FormControl();
  public filteredboards: ReplaySubject<Board[]> = new ReplaySubject<Board[]>(1);
  protected _onDestroy = new Subject<void>();

  protected departments: Departments[] = [];
  public departmentCtrl: FormControl = new FormControl();
  public departmentFilterCtrl: FormControl = new FormControl();
  public filteredDepartment: ReplaySubject<Departments[]> = new ReplaySubject<Departments[]>(1);

  firstFormGroup = this._formBuilder.group({
    grievanceTypeCtrl: ['', [Validators.required]],
    departmentCtrl: ['', [Validators.required]],
    boardCtrl: ['', [Validators.required]],
    levelCtrl: ['', [Validators.required]],
    excellationCtrl: ['', [Validators.required]],
  })
  constructor(public _formBuilder: FormBuilder,
    public grievanceTypeService: GrievanceTypeService,
    public router: Router,
    public dialog: MatDialog,
    private commonFunction: CommonFunction) { }

  async ngOnInit() {
    this.loadBoards();
    this.levels = this.commonFunction.getLevels()
    this.Excellationdays =  this.commonFunction.getEscalationDays()
  }


  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  async loadBoards() {
    //call to load board
    this.displayProgressSpinner();
    const response: any = await this.grievanceTypeService.loadBoard();
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.boards = response
        //set boards in array  
        this.boardCtrl.setValue(this.boards[10]);
        this.filteredboards.next(this.boards.slice());
        this.boardFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterboards();
          });
        //
      } else if (response[0].status == ProjectConstants.responseStatusFailure) {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")     
    }
  }


  // filter boards
  protected filterboards() {
    if (!this.boards) {
      return;
    }
    let search = this.boardFilterCtrl.value;
    if (!search) {
      this.filteredboards.next(this.boards.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredboards.next(
      this.boards.filter(board => board.boardName.toLowerCase().indexOf(search) > -1)
    );
  }
  //


  // select board dependant on grievance type
  async selectBoard(boards: any) {
    this.displayProgressSpinner();
    const response: any = await this.grievanceTypeService.loadDepartments(boards);
    
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.departments = response;
        this.departmentCtrl.setValue(this.departments[10]);
        this.filteredDepartment.next(this.departments.slice());
        this.departmentFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtereDepartments();
          })
        }else{
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      }
    }

  //department type filter
  protected filtereDepartments() {
    if (!this.departments) {
      return;
    }
    let search = this.departmentFilterCtrl.value;
    if (!search) {
      this.filteredDepartment.next(this.departments.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDepartment.next(
      this.departments.filter(department => department.departmentName.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  //
  async submitForm() {
    if (this.firstFormGroup.valid) {
        const data = {
        'gtGrievanceType': this.firstFormGroup.controls['grievanceTypeCtrl'].value,
        'fkDepid': this.firstFormGroup.controls['departmentCtrl'].value,
        'fkBdid': this.firstFormGroup.controls['boardCtrl'].value,
        'gtLevels': this.firstFormGroup.controls['levelCtrl'].value,
        'gtEscalationDuration': this.firstFormGroup.controls['excellationCtrl'].value,
      }
      this.displayProgressSpinner();
      const response: any = await this.grievanceTypeService.submitGrievanceType(data);
      this.progressSpinnerDialog.close()
      if (response != null && !response.error) {
        if (response.status == ProjectConstants.responseStatusSuccess) {
          await this.commonFunction.successToast(ProjectConstants.gtypeSuccessMsg,false,"")
          this.router.navigate(['secure/grievance-type-list'])
        }
        else if (response.status == ProjectConstants.responseStatusFailure) {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        }
        else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"") 
      }
    } else {
      this.isSubmitDisabled = false;
    }
  }
}
